import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PSPTaskResponse } from 'src/app/_models/PSP/psp-task.model';
import { baseUrl } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PSPProgramResponse } from 'src/app/_models/PSP/psp-program-model';

@Injectable({
  providedIn: 'root'
})
export class PspProgramsService {
  private programsUrl = 'api/AdminPspPrograms';

  constructor(private http: HttpClient) {}

  getAllPrograms(params?): Observable<PSPProgramResponse> {
    return this.http.get<PSPProgramResponse>(`${this.programsUrl}/GetProgramsNames`, {
      params,
    });
  }

  getAllProgramsByCompanyId(id: number): Observable<any> {
    const params = new HttpParams().set('id', id);

    return this.http.get(`${this.programsUrl}/GetAllProgramsByCompanyId`, {params});
  }
}
